export function HistogramTooltip({ seriesName, value, dataIndex }) {
  return `
    <div class="chart-tooltip">
      <table>
        <tbody>
          <tr>
            <th>${seriesName} bin:</th>
            <td class="active">${value[0]}</td>
          </tr>
          <tr>
            <th>Total Pairs:</th>
            <td class="active">${value[1]}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;
}
